export const getValueFromEnum = <T extends Record<string, string>>(key: string, obj: T) => {
    return obj[key];
};
